//#region IMPORTS
import { TrashIcon } from "@heroicons/react/24/outline";
import { Fragment } from "react";
//#endregion

//#region INTERFACE
interface Props {
  tooltipContent?: string;
  deleteHandler: () => void;
  tooltipId?: string;
  disabled?: boolean;
  hide?: boolean;
}
//#endregion

export default function MainTableRowActionDelete({
  tooltipContent = "Delete item",
  deleteHandler,
  tooltipId,
  disabled = false,
  hide = false,
}: Props) {
  //#region SETUP
  return !hide ? (
    <Fragment>
      <button
        data-tooltip-content={tooltipContent}
        data-tooltip-id={tooltipId + "delete"}
        className="flex items-center"
        disabled={disabled}
      >
        <TrashIcon
          className="h-4 w-4 text-rose-400 hover:cursor-pointer hover:text-rose-300"
          type="button"
          onClick={deleteHandler}
        />
      </button>
    </Fragment>
  ) : null;
}
